import { z } from 'zod'
import type { TFunction } from '@kostbar/i18n'

// Pricing item schema
export const buildPricingItemSchema = (t: TFunction<'pricing'>) =>
  z.object({
    sku: z.string().min(1, t('validation.skuRequired')).max(50),
    priceGrossCents: z.number().int().min(0, t('validation.pricePositive')),
  })

export type PricingItem = z.infer<ReturnType<typeof buildPricingItemSchema>>

// Validation result
export interface ValidationError {
  row: number
  field: string
  message: string
}

export interface ValidationResult {
  valid: boolean
  errors: Array<ValidationError>
  items: Array<PricingItem>
}
